import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { AuthContext } from '../../../App/App';
import { CSContext } from './CustomerServices';
import axios from 'axios';
import swal from 'sweetalert';

function ModalDeleteCustomerServices() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateCS, dispatchCS } = useContext(CSContext);

    const [renderModal, setRenderModal] = useState(<Fragment />)

    const handleCencelClick = (event) => {
        event.preventDefault()
        dispatchCS({
            type: "MODAL_DELETE",
            modalDelete: { status: !stateCS.modalDelete.status }
        })
    }

    const handleSubmitClick = (event) => {
        event.preventDefault();
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.delete(`/api/v1/helpdesk/setting/customer-services/customer-service/${stateCS.selected}`, config)
            .then(res => {
                dispatchCS({
                    type: "TRIGGER",
                    trigger: "delete-cs",
                    temp: { id: stateCS.selected }
                })
                dispatchCS({
                    type: "MODAL_DELETE",
                    modalDelete: { status: !stateCS.modalDelete.status }
                })
                swal("Success!", `${res.data.message}`, "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    useEffect(() => {
        if (stateCS.modalDelete.status == true) {
            //find cs
            const cs = stateCS.customerServices.find(cs => cs.id == stateCS.selected)
            setRenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={stateCS.modalDelete.status} backdrop={'static'} keyboard={true}>
                        <ModalHeader toggle={handleCencelClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            Delete Admin
                        </ModalHeader>
                        <ModalBody>
                            <p>Are you sure you want to delete this user?</p>
                            <ul style={{ listStyleType: 'none' }}>
                                <li>Username : {cs.username}</li>
                                <li>Email : {cs.email}</li>
                                <li>Role : {cs.role.name}</li>
                            </ul>
                        </ModalBody>
                        <ModalFooter>
                            <Button style={{ textTransform: 'capitalize' }} color="secondary" onClick={handleCencelClick}>Cancel</Button>
                            <Button style={{ textTransform: 'capitalize' }} color="danger" onClick={handleSubmitClick}> Delete <i className="fas fa-eraser"></i> </Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>)
        } else {
            setRenderModal(<Fragment />)
        }
    }, [stateCS.modalDelete])
    return (renderModal)
}

export default ModalDeleteCustomerServices
